import React from "react";
import { useIsMobile } from "../../hooks/useIsMobile";

interface Props {
  totalGws: number;
  currentGwNumber: number;
  startGwNumber: number;
  status: "PREPARING" | "RUNNING" | "COMPLETED";
}

export default function LeagueProgressBar({ totalGws, currentGwNumber, startGwNumber, status }: Props) {
  const isMobile = useIsMobile();
  const barColor =
    status === "RUNNING"   ? "var(--color-success)" :
    status === "COMPLETED" ? "var(--color-text-dim)" :
                             "var(--color-warning)"; // PREPARING — amber
  const pct = totalGws > 0 ? Math.round((currentGwNumber / totalGws) * 100) : 0;
  const startPct = totalGws > 0 ? (startGwNumber / totalGws) * 100 : 0;
  const showStartMarker = startGwNumber > 1;

  return (
    <div style={{ marginBottom: isMobile ? "0.75rem" : "1.25rem" }}>
      {!isMobile && (
        <div style={{ marginBottom: "0.4rem" }}>
          <span style={{
            fontSize: "0.6rem",
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            color: "var(--color-text-dim)",
          }}>
            Competition Progress
          </span>
        </div>
      )}
      <div style={{
        position: "relative",
        height: 6,
        background: "var(--color-border-subtle)",
        borderRadius: 3,
        overflow: "visible",
      }}>
        {/* Filled portion */}
        <div style={{
          position: "absolute",
          left: 0,
          top: 0,
          height: "100%",
          width: `${pct}%`,
          background: barColor,
          borderRadius: 3,
          transition: "width 0.4s ease",
        }} />
        {/* League start marker */}
        {showStartMarker && (
          <div style={{ position: "absolute", left: `${startPct}%`, top: -3, transform: "translateX(-50%)" }}>
            <div style={{
              width: 2,
              height: 12,
              background: "var(--color-accent-2)",
              borderRadius: 1,
            }} />
            <div style={{
              position: "absolute",
              top: 14,
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: "0.58rem",
              fontWeight: 600,
              color: "var(--color-accent-2)",
              whiteSpace: "nowrap",
            }}>
              GW{startGwNumber}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
